
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */

import DocsBeta from 'src/components/docs/DocsBeta/index.tsx';
import Sandbox from 'plaid-threads/Icons/Sandbox';
import Rocket from 'plaid-threads/Icons/Rocket';
import Help from 'plaid-threads/Icons/Help';
import AddCircle from 'plaid-threads/Icons/AddCircle';
import Wallet from 'plaid-threads/Icons/Wallet';
import Transfer from 'plaid-threads/Icons/Transfer';
import Webhooks from 'plaid-threads/Icons/Webhooks';
import Terminal from 'plaid-threads/Icons/Terminal';
import ProductLiabilities from 'plaid-threads/Icons/ProductLiabilities';
import Institution from 'plaid-threads/Icons/Institution';
import GuideIcon from 'plaid-threads/Icons/Guide';
import Book from 'plaid-threads/Icons/BookOpen';
import Build from 'plaid-threads/Icons/Build';
import External from 'plaid-threads/Icons/External';
import Libraries from 'plaid-threads/Icons/Libraries';
import Actions from '../../../components/docs/Actions';
import Overview from '../../../components/docs/Overview';
export const metadata = {
  layout: 'overview',
  description: 'Optimize your income verification process with document, payroll, and bank-based Income verification',
  section: 'Income',
  title: 'Overview'
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
      console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
      return <div {...props}/>
    };
const Callout = makeShortcode("Callout");
const YouTubeEmbed = makeShortcode("YouTubeEmbed");
const layoutProps = {
  metadata
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <Overview.Header product='Income'>{metadata.description}</Overview.Header>
    <Actions.SmallWrapper miniTitle='Get started with Income'>
  <Actions.SmallCard icon={<Libraries mdxType="Libraries" />} title='API Reference' link='/docs/api/products/income/' />
  <Actions.SmallCard icon={<Rocket mdxType="Rocket" />} title='Quickstart' link='https://github.com/plaid/income-sample' />
  <Actions.SmallCard icon={<External mdxType="External" />} title='Demo' link='https://plaid.coastdemo.com/share/66fb0a180582208ffa82103e?zoom=100' />
    </Actions.SmallWrapper>
    <h4 {...{
      "id": "overview"
    }}>{`Overview`}</h4>
    <Callout mdxType="Callout">
      <p>{`Most new customers should use the `}<a parentName="p" {...{
          "href": "/docs/check"
        }}>{`Consumer Report Income solution`}</a>{` instead of Income. Consumer Report includes an FCRA-compliant solution providing details on over a dozen categorized income streams along with ready-made, model-driven attributes like historical gross and net income to streamline debt-to-income calculations and income verification. It also provides details like forecasted income, employer name, income frequency, and predicted next payment date. `}</p>
      <p>{`Income is currently recommended only for use cases not supported by Consumer Report, such as underwriting outside the US, or Payroll or Document Income based flows.`}</p>
    </Callout>
    <p>{`Plaid Income (US, CA, and UK only) helps you verify anyone's income and employment in seconds, facilitating an improved decisioning and underwriting process. Depending on the Income product you choose, you can request information such as pay stub data, income streams, and historical income. `}</p>
    <p>{`You can enable multiple different methods of income verification, then use the appropriate one for your situation. For example, you might enable Bank Income and also provide Document Income as a fallback for customers who prefer not to link their bank account or don't bank with a Plaid-supported institution.`}</p>
    <p>{`You can verify a user's income via three products:`}</p>
    <p><a parentName="p" {...{
        "href": "/docs/income/document-income"
      }}><strong parentName="a">{`Document Income:`}</strong></a>{` Retrieve gross and/or net income information via user-uploaded documents such as a pay stub, bank statement, W-2, or 1099 form.`}</p>
    <p><a parentName="p" {...{
        "href": "/docs/income/payroll-income"
      }}><strong parentName="a">{`Payroll Income (US only):`}</strong></a>{` Instantly retrieve employment and gross income information, including the information available on a pay stub, from a user-connected payroll account. Supports approximately 80% of the US workforce, including gig income workers. `}</p>
    <p><a parentName="p" {...{
        "href": "/docs/income/bank-income"
      }}><strong parentName="a">{`Bank Income:`}</strong></a>{` Instantly retrieve net income information from a user-connected bank account. Data available includes a breakdown of income streams to the account, as well as recent and historical income. `}</p>
    <p>{`For a fuller view of a borrower's financial situation, Income can also be used with `}<a parentName="p" {...{
        "href": "/docs/assets"
      }}>{`Assets`}</a>{`, which provides user-permissioned asset verification. If you need exact copies of a user's statements, see `}<a parentName="p" {...{
        "href": "/docs/statements"
      }}>{`Statements`}</a>{`.`}</p>
    <p>{`Income is a product of Plaid Inc., which is not a consumer reporting agency. To learn more about products offered by Plaid Consumer Reporting Agency, Inc. (Plaid CRA), see `}<a parentName="p" {...{
        "href": "/docs/check/"
      }}>{`Plaid Check`}</a>{`. Income can't be used in the same Link flow as Plaid CRA products.`}</p>
    <YouTubeEmbed videoId='Hc-MpibSxJE' alignment='full' title='Plaid Income in 3 minutes' caption='Prefer to learn by watching? Get an overview of how Income works in just 3 minutes!' mdxType="YouTubeEmbed" />
    <h4 {...{
      "id": "next-steps"
    }}>{`Next steps`}</h4>
    <p>{`To learn more about integrating Income, see the docs for the Income product you would like to use: `}<a parentName="p" {...{
        "href": "/docs/income/document-income"
      }}>{`Document Income`}</a>{`, `}<a parentName="p" {...{
        "href": "/docs/income/payroll-income"
      }}>{`Payroll Income`}</a>{`, or `}<a parentName="p" {...{
        "href": "/docs/income/bank-income"
      }}>{`Bank Income`}</a>{`. `}</p>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

            export const tableOfContents = [
      {
        id: "overview",
        level: 4,
        title: "Overview",
      },
{
        id: "next-steps",
        level: 4,
        title: "Next steps",
      }
];
          
layoutProps.tableOfContents = tableOfContents;
MDXContent.layoutProps = layoutProps;

MDXContent.layout = function (props) { return <DocsBeta {...props} /> };
